import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import EstateJurisdictionLang from '/@/modules/predefined/services/EstateJurisdictionLang';

export class EstateUpsellClearWillComponentProp extends Enum {
  static NEEDS_SPOUSE_TESTAMENT_GUIDANCE = {
    key: 'needs_spouse_testament_guidance',
    get title() {
      return Lang.t('estateupsell.do-you-your');
    },
    get smallTitle() {
      return Lang.t('estateupsell.spouse-intentions');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.if-our-impact'
      );
    }
  };

  static NEEDS_EXECUTOR_GUIDANCE = {
    key: 'needs_clear_estate_executorship_guidance',
    get title() {
      return Lang.t('estateupsell.do-executor-you', {
        executor: EstateJurisdictionLang.executor
      });
    },
    get smallTitle() {
      return Lang.t('estateupsell.executor-guidance');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.this-success-it'
      );
    }
  };

  static NEEDS_ASSET_OWNERSHIP_GUIDANCE = {
    key: 'needs_asset_ownership_guidance',
    get title() {
      return Lang.t('estateupsell.do-how-your');
    },
    get smallTitle() {
      return Lang.t('estateupsell.asset-ownership');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.the-our-to'
      );
    }
  };

  static NEEDS_SPECIFIC_GIFT_IMPACT_GUIDANCE = {
    key: 'needs_specific_gift_impact_guidance',
    get title() {
      return Lang.t('estateupsell.are-how-impact');
    },
    get smallTitle() {
      return Lang.t('estateupsell.specific-gifts');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.remember-consider-the'
      );
    }
  };

  static NEEDS_CONTINGENCY_PLANNING_GUIDANCE = {
    key: 'needs_contingency_planning_guidance',
    get title() {
      return Lang.t('estateupsell.contingency-planning');
    },
    get smallTitle() {
      return Lang.t('estateupsell.contingency-planning');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.accounting-plan-of'
      );
    }
  };

  static NEEDS_TRUST_SOLUTIONS_GUIDANCE = {
    key: 'needs_trust_solutions_guidance',
    get title() {
      return Lang.t('estateupsell.trust-solutions-benefit');
    },
    get smallTitle() {
      return Lang.t('estateupsell.trust-solutions');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.implementing-and-provide'
      );
    }
  };

  static NEEDS_CLEAR_ESTATE_EXECUTORSHIP_GUIDANCE = {
    key: 'needs_clear_estate_executorship_guidance',
    get title() {
      return Lang.t('estateupsell.consider-clearestate-executor');
    },
    get smallTitle() {
      return Lang.t('estateupsell.clearestate-as-executor');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.engaging-clearestate-expertise'
      );
    }
  };

  static NEEDS_FAMILY_SPECIFIC_GUIDANCE = {
    key: 'needs_family_specific_guidance',
    get title() {
      return Lang.t('estateupsell.review-your-family');
    },
    get smallTitle() {
      return Lang.t('estateupsell.family-specifics-circumstances');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.are-arrangements-things'
      );
    }
  };

  static NEEDS_DOCUMENTS_IN_VAULT = {
    key: 'needs_store_documents_in_vault',
    get title() {
      return Lang.t('estateupsell.save-documents-the');
    },
    get smallTitle() {
      return Lang.t('estateupsell.save-documents-the');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.safely-when-the'
      );
    }
  };

  static BALANCE = {
    key: 'balance',
    get title() {
      return Lang.t('estate.balance');
    },
    get paragraph() {
      return Lang.t(
        'accounting.build-value-estate'
      );
    }
  };

  static CONNECTED_ACCOUNTS = {
    key: 'connected_accounts',
    get title() {
      return Lang.t('estate.connected-accounts');
    },
    get paragraph() {
      return Lang.t(
        'accounting.safely-keep-up'
      );
    }
  };

  static RECENT_DOCUMENTS = {
    key: 'recent_documents',
    get title() {
      return Lang.t('estate.recent-documents');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.safely-when-cabinets'
      );
    }
  };

  static NEEDS_NEW_MESSAGES = {
    key: 'needs_new_messages',
    get title() {
      return Lang.t('estateupsell.new-messages');
    },
    get smallTitle() {
      return Lang.t('estateupsell.chat-estate-specialist');
    },
    get paragraph() {
      return Lang.t(
        'estateupsell.an-answer-ones'
      );
    }
  };
}
